/* eslint-disable */
import axios from "axios";
import store from "@/store";
import customModal from "../customModal/customModal.vue";

export default {
    name: "ManageRiskItemModal",
    components: {
        customModal,
    },
    props: {
        riskEditData: Object,
        ctqData: Object,
        fromPage: String,
    },
    emits: ["closeModal", "reloadList"],

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",
            studyId: "",
            saving: false,
            isEdit: false,
            errors: {
                riskId: "",
                riskStatement: "",
            },
            form: this.buildDefaultForm(),
        };
    },

    computed: {
        modalTitle() {
            return this.isEdit ? "Edit Risk" : "Add Risk";
        },
        ctqFieldsLocked() {
            return this.fromPage === "CTQ Registry";
        },
    },

    mounted() {
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        this.initForm();
    },

    watch: {
        "form.probability"() {
            this.calculateRpn();
        },
        "form.impact"() {
            this.calculateRpn();
        },
        "form.detectability"() {
            this.calculateRpn();
        },
    },

    methods: {
        buildDefaultForm() {
            return {
                studyId: "",
                riskId: "",
                ctqId: "",
                ctqFactor: "",
                riskStatement: "",
                failureMode: "",
                rootCause: "",
                consequence: "",
                riskCategory: "",
                subCategory: "",
                typeOfRisk: "",
                phase: "",
                levelOfScrutiny: "",
                probability: 0,
                impact: 0,
                detectability: 0,
                rpn: 0,
                riskLevel: "",
                residualRpn: 0,
                residualRiskLevel: "",
                scoreRationale: "",
                scoringStatus: "",
                riskOwner: "",
                detectionMethod: "",
                objectives: "",
                status: "",
                executionType: "",
                isActive: true,
            };
        },

        initForm() {
            if (this.riskEditData && this.riskEditData.id) {
                this.isEdit = true;
                this.form = Object.assign(this.buildDefaultForm(), this.riskEditData);
            } else {
                this.isEdit = false;
                this.form = this.buildDefaultForm();
                this.form.studyId = this.studyId;
                this.form.ctqId = this.ctqData?.ctqid || "";
                this.form.ctqFactor = this.ctqData?.ctqFactor || "";
            }
        },

        calculateRpn() {
            var p = Number(this.form.probability) || 0;
            var i = Number(this.form.impact) || 0;
            var d = Number(this.form.detectability) || 0;
            this.form.rpn = p * i * d;
        },

        closeModal() {
            this.$emit("closeModal");
        },

        validate() {
            this.errors = { riskId: "", riskStatement: "" };
            let isValid = true;

            if (!this.form.riskId || !this.form.riskId.trim()) {
                this.errors.riskId = "Risk ID is required.";
                isValid = false;
            }
            if (!this.form.riskStatement || !this.form.riskStatement.trim()) {
                this.errors.riskStatement = "Risk Statement is required.";
                isValid = false;
            }
            if (!isValid) {
                this.$nextTick(() => {
                    if (this.errors.riskId && this.$refs.riskId) {
                        this.$refs.riskId.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                        this.$refs.riskId.focus();
                    } else if (this.errors.riskStatement && this.$refs.riskStatement) {
                        this.$refs.riskStatement.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                        this.$refs.riskStatement.focus();
                    } 
                });
            }

            return isValid;
        },

        async save() {
            if (!this.validate()) return;

            this.saving = true;

            try {
                if (this.isEdit) {
                    var payload = Object.assign({}, this.form);
                    delete payload.id;

                    await axios.put(
                        `${this.baseurl}/forms/ctq/updateriskitem`,
                        payload,
                        {
                            params: { id: this.riskEditData.id },
                            headers: {
                                Authorization: `Bearer ${this.token}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );
                    alert("Risk updated successfully.");
                } else {
                    var createPayload = Object.assign({}, this.form, {
                        studyId: this.studyId,
                    });

                    await axios.post(
                        `${this.baseurl}/forms/ctq/createriskitem`,
                        createPayload,
                        {
                            headers: {
                                Authorization: `Bearer ${this.token}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );
                    alert("Risk created successfully.");
                }

                this.$emit("reloadList");
                this.closeModal();
            } catch (error) {
                console.error("Error saving risk item:", error);
                alert(
                    (error && error.response && error.response.data && error.response.data.message) ||
                    "Failed to save risk item."
                );
            } finally {
                this.saving = false;
            }
        },
    },
};